// extracted by css-extract-rspack-plugin
export default {"cls1":"BottomSection-cls1_6Op","cls2":"BottomSection-cls2_Zn5 BottomSection-cls1_6Op"};